import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { Select } from '@mui/material';
import clsx from 'clsx';

var KSelect = function (_a) {
    var className = _a.className, _b = _a.testId, testId = _b === void 0 ? "KSelect" : _b, sx = _a.sx, rest = __rest(_a, ["className", "testId", "sx"]);
    return (React__default.createElement(Select, __assign({ "data-testid": testId, className: clsx("KSelect", className), variant: "standard", sx: __assign({ fontSize: ".8rem", padding: "0px", color: function (theme) { return theme.palette.text.primary; } }, sx), MenuProps: { className: clsx("KSelect-Menu", "".concat(className, "-Menu")) }, disableUnderline: true }, rest)));
};

export { KSelect as default };
//# sourceMappingURL=index.js.map
